import { render, staticRenderFns } from "./AdminNoticeList.vue?vue&type=template&id=1cc9358c&"
import script from "./AdminNoticeList.vue?vue&type=script&lang=js&"
export * from "./AdminNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports